import { render, staticRenderFns } from "./DashFuncionarioIndustria.vue?vue&type=template&id=e6484520&scoped=true&"
import script from "./DashFuncionarioIndustria.vue?vue&type=script&lang=js&"
export * from "./DashFuncionarioIndustria.vue?vue&type=script&lang=js&"
import style0 from "./DashFuncionarioIndustria.vue?vue&type=style&index=0&id=e6484520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6484520",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBadge,VBtn,VChip,VCol,VContainer,VIcon,VRow,VTooltip})
